import SubMessageTemplates from '../views/submessage/templates.vue'

export default [
  {
    path: '/submessage/templates',
    name: "SubMessageTemplates",
    component: SubMessageTemplates
  }
]